import * as React from 'react';
import { useContext } from 'react';
import ModalDefault from './ModalDefault';
import { ModalContext } from '../../provider/ModalProvider';
import { IoCloseSharp } from 'react-icons/io5';

import { d_flex_center, dir_column, CloseButton } from '../../styles/common';
import { styled, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

const StyledModalAlertWrap = styled(Box)(props => ({
  backgroundColor: '#fff',
  borderRadius: '4px',
  overflow: 'hidden',
}));

const StyledModalAlert = styled(Box)(props => ({
  position: 'relative',
  width: '35.7rem',
  maxWidth: '480px',
  borderRadius: '4px',
  padding: '32px 16px',
  backgroundColor: '#000',
  opacity: '0.75',
  [props.theme.breakpoints.up('xxl')]: {
    fontSize: '1.1rem',
  },
  [props.theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  whiteSpace: 'pre-wrap',
}));

interface StyledTitleProps {
  is_login: boolean;
}

const StyledTitle = styled(Box)<StyledTitleProps>(props => ({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  [props.theme.breakpoints.up('xxl')]: {
    fontSize: '1.1rem',
  },
  [props.theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  lineHeight: '2rem',
  color: '#fff !important',
  caretColor: '#fff !important',
  ...d_flex_center,
  ...dir_column,

  '.sub_title': {
    fontWeight: '300',
    fontSize: '1.1rem',
  },
}));

function ModalAlertOrigin() {
  const { modal_alert_origin } = useContext(ModalContext);
  const location = useLocation();

  return (
    <>
      <ModalDefault
        visible={modal_alert_origin.data.visible}
        opacity={46}
        onClose={() => {
          return;
        }}
      >
        <StyledModalAlertWrap id='modal_alert'>
          <StyledModalAlert>
            <StyledTitle
              is_login={location.pathname.includes('login')}
              dangerouslySetInnerHTML={{ __html: modal_alert_origin.data.title }}
            ></StyledTitle>
            {modal_alert_origin.data.timeout ? null : modal_alert_origin.data.use_close_button === false ? null : (
              <CloseButton
                sx={{
                  top: '0.625rem',
                  right: '0.625rem',
                  width: '1.625rem',
                  height: '1.625rem',
                  svg: { width: '1.375rem', height: '1.375rem' },
                  backgroundColor: '#fff',
                }}
                onClick={() => modal_alert_origin.closeModalAlertOrigin()}
              >
                <IoCloseSharp />
              </CloseButton>
            )}
          </StyledModalAlert>
        </StyledModalAlertWrap>
      </ModalDefault>
    </>
  );
}

export default ModalAlertOrigin;
